<template>
  <pie-chart
    v-if="hasChartData"
    :chart-data="chartData"
    :tooltips-callback-cfg="tooltipsCallbackCfg"
    :width="300"
    :height="300"
    class="attendance-chart"
    :legendCfg="{
      position: 'right'
    }"
  ></pie-chart>
  <no-data-found v-else class="mx-auto"></no-data-found>
</template>

<script>
import PieChart from "@/components/Base/PieChart";
import { ATTENDANCE_COLORS } from "../utils";
import isEmpty from "lodash/isEmpty";
import NoDataFound from "@/components/Base/Illustration/NoDataFound.vue";

export default {
  name: "attendance-chart",
  components: { PieChart, NoDataFound },
  props: ["attendanceData"],
  data() {},
  computed: {
    tooltipsCallbackCfg() {
      return {
        title: {
          prefix: this.$t("attendance_report.present") + ": "
        },
        label: true
      };
    },
    chartData() {
      return this.generateChartDataFrom(this.attendanceData);
    },
    hasChartData() {
      return this.chartData?.datasets[0]?.data?.length;
    }
  },
  methods: {
    generateChartDataFrom(attendanceData) {
      if (isEmpty(attendanceData)) return null;

      const { labels, data } = attendanceData;

      return {
        labels,
        datasets: [
          {
            data,
            backgroundColor: labels.map(label => ATTENDANCE_COLORS[label]),
            borderWidth: 1
          }
        ]
      };
    }
  }
};
</script>

<style lang="scss" scoped></style>
